import React, { FC, useState, useEffect } from "react";
import Input from "shared/Input/Input";
import CommonLayout from "./CommonLayout";
import FormItem from "./FormItem";
import { useHistory } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { addListing5 } from "actions/addListingActions";
import { IInput } from "types/interfaces";
import formatRupiah from "utils/toRupiah";

export interface PageAddListing8Props {}

const PageAddListing8: FC<PageAddListing8Props> = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { product } = useSelector((state: RootState) => state.productUpload);
  const [price, setPrice] = useState<IInput>({
    value: product.price,
    warning: "",
  });
  const [deposit, setDeposit] = useState<IInput>({
    value: product.deposit,
    warning: "",
  });
  const [minimalRent, setMinimalRent] = useState<IInput>({
    value: product.minRent,
    warning: "",
  });

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (price.value === "0") {
      return setPrice({ value: price.value, warning: "Harga tidak boleh 0" });
    }
    if (
      !price.warning &&
      !minimalRent.warning &&
      !deposit.warning &&
      price.value &&
      minimalRent.value
    ) {
      dispatch(
        addListing5(
          product.edit,
          parseInt(price.value),
          parseInt(minimalRent.value),
          parseInt(deposit.value || "0")
        )
      );
      history.push("/add-listing-10");
    }
  };

  useEffect(() => {
    if (!product.name) {
      history.push("/add-listing-1");
    }
  }, []);
  return (
    <CommonLayout
      index="05"
      backtHref="/add-listing-7"
      nextHref="/add-listing-10"
    >
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <h2 className="text-2xl font-semibold">Harga Sewa</h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            Tentukan harga sewa yang cocok dengan barang anda. Anda dapat pula
            menenetukan minimal durasi sewa barang anda.
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700 my-3"></div>
        {/* FORM */}
        <div className="space-y-8">
          {/* ITEM */}
          <FormItem label="Harga Sewa per Hari" required={true}>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <span className="text-gray-500 ">Rp</span>
              </div>
              <Input
                className="!pl-12 !pr-10"
                placeholder="10.000"
                type="text"
                value={price.value && formatRupiah(price.value)}
                onChange={(e) => {
                  let value = e.target.value.replace(/[^0-9]/g, "");
                  if (!Number(value) || !e.target.value) {
                    return setPrice({
                      value,
                      warning: "Masukkan harga sewa barang anda dengan benar",
                    });
                  }
                  setPrice({ value, warning: "" });
                }}
              />
            </div>
            {price.warning && (
              <span className="text-sm text-red-500">{price.warning}</span>
            )}
          </FormItem>
          {/* ----- */}
          <FormItem label="Minimal durasi sewa (hari)" required={true}>
            <Input
              placeholder="1"
              type="number"
              value={minimalRent.value}
              onChange={(e) => {
                setMinimalRent({ value: e.target.value, warning: "" });
                if (e.target.valueAsNumber < 1 || !e.target.value) {
                  setMinimalRent({
                    value: e.target.value,
                    warning: "Minimal durasi sewa adalah 1 hari",
                  });
                }
              }}
            />
            {minimalRent.warning && (
              <span className="text-sm text-red-500">
                {minimalRent.warning}
              </span>
            )}
          </FormItem>

          {/* ----- */}
          <FormItem label="Minimal Biaya Deposit (jika perlu)">
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <span className="text-gray-500 ">Rp</span>
              </div>
              <Input
                className="!pl-12 !pr-10"
                placeholder="1"
                type="text"
                value={deposit.value && formatRupiah(deposit.value)}
                onChange={(e) => {
                  let value = e.target.value.replace(/[^0-9]/g, "");
                  if (!value) {
                    return setDeposit({
                      value,
                      warning: "Masukkan biaya deposit dengan benar",
                    });
                  }

                  setDeposit({ value, warning: "" });
                }}
              />
            </div>
            {deposit.warning && (
              <span className="text-sm text-red-500">{deposit.warning}</span>
            )}
          </FormItem>
        </div>
        <div className="flex justify-end space-x-5 mt-3">
          <ButtonSecondary href={"/add-listing-7"}>Kembali</ButtonSecondary>
          {product.edit ? (
            <ButtonPrimary type="submit">{"Perbaharui"}</ButtonPrimary>
          ) : (
            <ButtonPrimary type="submit">{"Unggah"}</ButtonPrimary>
          )}
        </div>
      </form>
    </CommonLayout>
  );
};

export default PageAddListing8;
